import React, { createContext, useContext } from 'react';
import useFormStateData from 'hooks/affordaPortalFormState/useFormStateData';

export const FormStateContext = createContext(null);

export const useFormStateContext = () => {
  const context = useContext(FormStateContext);
  if (!context) {
    throw new Error(
      'useFormStateContext must be used within a FormStateProvider',
    );
  }

  return context;
};

export const FormStateProvider = ({ children }) => {
  const { data, update, deleteForm } = useFormStateData();

  return (
    <FormStateContext.Provider
      value={{
        data,
        update,
        deleteForm,
      }}
    >
      {children}
    </FormStateContext.Provider>
  );
};
